module.exports = "/_next/static/images/3f3be01e7f67155fd58b54ea4a428280-smile-icon.svg";